import { gql } from '@apollo/client/core';

export const GET_ERROR_INFO = gql`
  {
    errorInfo @client {
      isOpen
      typeOpen
    }
  }
`;
